var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p54jdy3txa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20327",
    transform: "translate(-7 373)",
    style: {
      fill: "none"
    },
    d: "M0 0h100v152H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 214",
    transform: "translate(7 -373)",
    style: {
      clipPath: "url(#p54jdy3txa)"
    }
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": 2,
    transform: "translate(33 497)",
    style: {
      stroke: "currentColor",
      strokeWidth: 4,
      fontSize: 140,
      fontFamily: "Sarabun-Bold,Sarabun",
      fontWeight: 700,
      letterSpacing: "-.1em",
      fill: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineTwo);
export default __webpack_public_path__ + "static/media/outline-two.58c2795b9e3e64faae7ab2e9d64fa843.svg";
export { ForwardRef as ReactComponent };